import {Component, computed, inject, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Api} from '../../../../api/api';
import {getCurrentConsumptionPrice, getCurrentFeedInPrice} from '../../../../api/functions';
import {CurrentEnergyPriceResponse} from '../../../../api/models';
import {rxResource} from '@angular/core/rxjs-interop';
import {catchError, from, of, switchMap} from 'rxjs';
import {LocationStateService} from '../../../../common/services/location-state.service';

const hasMarketPrice = (price?: CurrentEnergyPriceResponse) =>
  price?.marketPriceCtPerKwh != null || price?.marketPriceHourlyAverageCtPerKwh != null;

@Component({
  selector: 'app-energy-price-market',
  imports: [CommonModule],
  templateUrl: './energy-price-market.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './energy-price-market.component.css',
})
export class EnergyPriceMarketComponent {
  api = inject(Api);
  locationStateService = inject(LocationStateService);
  locationId = computed(() => this.locationStateService.currentLocation()?.id ?? '');
  // reiner Börsenpreis (Spot) – immer ohne Netzkosten, Abgaben und Aufschläge; für jede Location:
  // zuerst aus dem Bezugspreis, falls dort keiner geliefert wird aus dem Einspeisungspreis
  resource = rxResource({
    params: this.locationId,
    stream: ({params}) => {
      const load = (fn: typeof getCurrentConsumptionPrice | typeof getCurrentFeedInPrice) =>
        from(this.api.invoke(fn, {location_id: params})).pipe(catchError(() => of(undefined)));
      return load(getCurrentConsumptionPrice).pipe(
        switchMap((price) => (hasMarketPrice(price) ? of(price) : load(getCurrentFeedInPrice))),
        catchError((error) => {
          console.log('Mart price API does not respond.', error);
          return of(undefined);
        }),
      );
    },
  });
  marketPriceCt = computed(() => this.resource.value()?.marketPriceCtPerKwh);
  marketPriceHourlyCt = computed(() => this.resource.value()?.marketPriceHourlyAverageCtPerKwh);
}
